import EmployeesTimeStats from "./EmployeesTimeStats";

export default EmployeesTimeStats;